import React from 'react'
import S2_about_1 from "../../img/S2-about-1.png"
import S2_about_2 from "../../img/S2-about-2.png"
import S2_about_3 from "../../img/S2-about-3.png"
import S2_about_4 from "../../img/S2-about-4.png"
import S2_about_5 from "../../img/S2-about-5.png"
import S2_about_6 from "../../img/S2-about-6.png"


const S2_about = () => {
  return (
<section className='S2_about'>
<div className='container'>
    <div className='intro'>
        <span>A Few Words About</span>
        <h3>Our Team</h3> 
        <p>Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra.</p>          

    </div>

<div className='row mt-5'>
                  
<div className='col-lg-4 col-md-6'>
    <div className='card'>                
    <img src={S2_about_1} alt='S2_about_imges'/>
    <h5>Harvey Spector</h5>
    <span>Founder - CEO</span>                  
    </div>                     
    </div>          

<div className='col-lg-4 col-md-6'>
    <div className='card'>       
    <img src={S2_about_2} alt='S2_about_imges'/>  
    <h5>Jessica Pearson</h5>
    <span>COO</span> 
    </div> 
    </div> 
                  
<div className='col-lg-4 col-md-6'>
    <div className='card'>      
    <img src={S2_about_3} alt='S2_about_imges'/>
    <h5>Rachel Zain</h5>
    <span>Marketing Head</span>              
    </div>
    </div> 

<div className='col-lg-4 col-md-6'>
    <div className='card'>        
    <img src={S2_about_4} alt='S2_about_imges'/>
    <h5>Luise Litt</h5>
    <span>Lead Developer</span>              
    </div>
    </div> 
        
<div className='col-lg-4 col-md-6'>
    <div className='card'>              
    <img src={S2_about_5} alt='S2_about_imges'/>
    <h5>Katrina Bennett</h5>
    <span>Intern Designer</span>            
    </div>  
    </div> 

<div className='col-lg-4 col-md-6'>
    <div className='card'>                   
    <img src={S2_about_6} alt='S2_about_imges'/>
    <h5>Mike Ross</h5>
    <span>Intern Designer</span>
    </div> 
    </div>                   

</div>  
</div> 
</section>
  )
}

export default S2_about